var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 188,
    viewBox: "0 0 188 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_47_160)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168 152V78.6117C168.005 76.6318 167.617 74.6706 166.86 72.8412C166.103 71.0117 164.991 69.3503 163.589 67.9529L104.277 8.63427C101.462 5.81388 97.642 4.22705 93.6571 4.22249L20 4L43.1869 12.3417C47.7478 13.9733 51.8841 16.6086 55.2902 20.0531L150.262 115.927C153.595 119.284 156.234 123.265 158.028 127.642L168 152Z",
    fill: "url(#paint0_linear_47_160)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_47_160",
    x: 0,
    y: 0,
    width: 188,
    height: 188,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_47_160"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_47_160",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_47_160",
    x1: 21.5,
    y1: 5.5,
    x2: 168,
    y2: 152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33283A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#7EC78F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#7EC78F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33283A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenLine);
export default __webpack_public_path__ + "static/media/green_line.bb5a0630152936ba333b527168ee26cd.svg";
export { ForwardRef as ReactComponent };